module.exports = __webpack_public_path__ + "img/logo.74b1be43.png";